import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, ActivityIndicator, Picker, Platform, TextInput } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, article, button, pageContent, FontFamily, articleLists, FontWeight, input, Colors, Messages } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import ArticleItemHorizontal from '../article-item-horizontal';
import ScrollContainerView from '../scroll-container-view';
import { helpers } from '../../utils/helpers';
import PageBreak from '../page-break';
import ArticleItem from '../article-item';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import ButtonGradient from '../button-gradient';


const blueDots = getImagePath('icons/blue-dots.png');
const checkIcon = getImagePath('icons/check.png');

export class HomeFreeTrial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnDisable: true,
            email: '',
            referralMsg: {
                enable: false,
                type: '', // error / success
                msg: ''
            },
        }
    }

    signUp = () => {
        const { email } = this.state;
        this.setState({
            btnLoader: true,
            referralMsg: {
                enable: false,
                type: '',
                msg: ''
            }
        });

        if (helpers.validateEmail(email)) {
            this.setState({
                btnLoader: false
            });
            if (helpers.isWeb()) {
                this.props.navigateWeb(`/sign-up?redirect=/&email=${email}`)
            } else {
                this.props.navigateApp('/sign-up', { redirect: '/', verifyRedirect: '/', email: email });
            }
        }
        else {
            this.setState({
                btnLoader: false,
                referralMsg: {
                    enable: true,
                    type: 'error',
                    msg: 'Please enter a valid email'
                }
            });
        }
    }

    validateInput = (value) => {
        if (value) {
            this.setState({ btnDisable: false, email: value });
        } else {
            this.setState({ email: value, btnDisable: true })
        }
    }

    render() {
        let { email, btnDisable, referralMsg } = this.state;

        return (

            <View style={[ Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWebFull, helpers.isDesktop() && { marginTop: 10 }]}>
                <View style={[Flex.row, Margin.mt_5, Margin.mb_7]}>
                    {helpers.isDesktop() && <View>
                            <CustomImage
                                source={blueDots}
                                require={true}
                                style={{ width: 100, height: 85, position:'absolute', left: 0, top: '50%'  }}
                                webStyle={{ width: 100, height: 85, position:'absolute', left: 0, top: '50%'  }}
                            />
                        </View>}
                    <View style={[ helpers.isDesktop() && Padding.pt_5, Padding.pb_5, Flex.alignStart, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, {paddingHorizontal: helpers.isDesktop() ? 20 : 0, width: helpers.isDesktop() ? '65%' : '100%'}]}>
                        <View style={[Margin.mb_4, !helpers.isDesktop() && {textAlign: 'center',width: '100%'}]}>
                            {helpers.isDesktop() ?
                                <View style={[Helpers.borderBottom]}>
                                    <Text style={[pageContent.sectionTitle, helpers.isDesktop() && pageContent.sectionTitleDesktop,{width: helpers.isWeb() ? 'fit-content' : '100%', fontSize: helpers.isDesktop() ? 28 : 24}]}>Try us out</Text>
                                </View>
                                :
                                <View style={[ Flex.row, Flex.justfiyCenter,{position: 'relative', top: -18}]}>
                                    <View style={[{backgroundColor:'white', zIndex: 1, paddingHorizontal: 20}]}>
                                        <View style={[Helpers.borderBottom]}>
                                            <Text style={[pageContent.sectionTitle, helpers.isDesktop() && pageContent.sectionTitleDesktop, {paddingBottom: 5}]}>Try us out</Text>
                                        </View>
                                        <View style={{backgroundColor: '#f8fcff', height: 22, position: 'absolute', top: 20, right: 0 , left: 0, width: '100%', zIndex: -1}}></View>
                                    </View>
                                    <View style={[Helpers.titleLineLight]}></View>
                                </View>
                            }
                            <Text style={{fontFamily:FontFamily.regular, fontSize: helpers.isDesktop() ? 24 : 18, lineHeight: 34, color: '#000000', textAlign: 'center', marginBottom: helpers.isDesktop() ? 24 : 0, letterSpacing: 0.3, marginTop: 20, paddingHorizontal: helpers.isDesktop() ? 0 : 20 }}>Sign up now and get free starter credits</Text>
                        </View>
                        <View style={[ Flex.FlexWrap, Flex.fill, Padding.pt_5, Padding.pb_5, {paddingHorizontal: 40, borderWidth: 3, borderColor: '#3AACFF', backgroundColor:'white'}, !helpers.isDesktop() && {width: '90%', marginHorizontal: 'auto'}]}>
                            <Text style={[Padding.pb_2,{fontSize: helpers.isDesktop() ? 36 : 24, lineHeight: helpers.isDesktop() ? 54 : 40, fontFamily: FontFamily.abrilFatface, fontWeight: FontWeight.semiBold, color: '#0094FF'}]}>Free Trial</Text>
                            <View style={[Flex.row, Flex.alignStart, Margin.mr_2]}>                  
                                <CustomImage
                                    source={checkIcon}
                                    require={true}
                                    style={{ width: 20, height: 19, resizeMode: 'contain', marginTop: 3, marginRight: 15 }}
                                    webStyle={{ width: 20, height: 19, objectFit: 'contain', marginTop: 3, marginRight: 15 }}
                                /><Text style={{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: 27, marginBottom: helpers.isDesktop() ? 10 : 0, letterSpacing: 0.3 }}>10 credits, which do not expire.</Text>
                            </View>
                            <View style={[Flex.row, Flex.alignStart, Margin.mr_2]}>
                                <CustomImage
                                    source={checkIcon}
                                    require={true}
                                    style={{ width: 20, height: 19, resizeMode: 'contain', marginTop: 3, marginRight: 15 }}
                                    webStyle={{ width: 20, height: 19, objectFit: 'contain', marginTop: 3, marginRight: 15 }}
                                /><Text style={{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: 27, marginBottom: helpers.isDesktop() ? 10 : 0, letterSpacing: 0.3 }}>Gets archive access.</Text>
                            </View>
                            <View style={[Flex.row, Flex.alignStart, Margin.mr_2]}>
                                <CustomImage
                                    source={checkIcon}
                                    require={true}
                                    style={{ width: 20, height: 19, resizeMode: 'contain', marginTop: 3, marginRight: 15 }}
                                    webStyle={{ width: 20, height: 19, objectFit: 'contain', marginTop: 3, marginRight: 15 }}
                                /><Text style={{ fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: 27, marginBottom: helpers.isDesktop() ? 10 : 0, letterSpacing: 0.3 }}>Get access to newsletters</Text>
                            </View>
                            <View style={[Margin.mt_3, helpers.isDesktop() && Flex.row, !helpers.isDesktop() && { width: '100%' }]}>
                                <TextInput
                                    placeholder={'Email Id'}
                                    placeholderTextColor={Colors.placeholderTextColor}
                                    style={[input.Text, Padding.pt_1, Padding.pl_15, Padding.pb_1, Margin.mb_2, { backgroundColor: 'white', height: 46, borderColor: '#6C7AF6', borderWidth: 1, width: helpers.isDesktop() ? 400 : '100%' }]}
                                    onChangeText={this.validateInput}
                                    value={email}
                                />
                                <ButtonGradient
                                    title={'SIGN UP'}
                                    rootStyle={{
                                        btnWrapper: [button.primaryGradientBtn, { height: 46, borderRadius: 0, flex: 1 }],
                                        btnText: [button.primaryGradientText, { fontSize: 14, paddingLeft: 25, paddingRight: 25, paddingTop: helpers.isDesktop() ? 0 : 15, paddingBottom: helpers.isDesktop() ? 0 : 15}]
                                    }}
                                    onClick={this.signUp}
                                    disable={btnDisable}
                                />
                            </View>
                            {referralMsg.enable &&
                                <View style={[{ marginTop: 5 }]}>
                                    <Text style={[referralMsg.type == 'success' ? Messages.successText : Messages.errorText]}>{referralMsg.msg}</Text>
                                </View>
                            }
                        </View>
                    </View>
                    <View style={{ backgroundColor: '#F8FCFF', width: helpers.isDesktop() ? '60%' : '100%', height: '100%', position: 'absolute', right: 0, zIndex: -1 }} />
                </View>
            </View>
        );
    }
}

export default HomeFreeTrial;